import './App.css';
import Body from './Body';


const App =()=> {
  return (
    <div className='' >
      
      <Body/>
      
    </div>
  );
}

export default App;
